// src/components/VideoGrid.js
import React from 'react';
import VideoCard from './VideoCard';
import '../styles/VideoGrid.css';

const videoData = [
    { id: 1, title: 'Digital assessments', src: '/resources/Correction_teacher_LQ_Trim.mov', thumbnail: '/resources/thumbnail1.jpg', position: [1,1], gridSpan: { columns: 2, rows: 2 }, sizeClass: 'size-90' },
    { id: 3, title: 'Quiz generation', src: '/resources/Test_LQ.mov', thumbnail: '/resources/thumbnail3.jpg', position: [1,4], gridSpan: { columns: 1, rows: 2 }, sizeClass: 'size-90' },
    { id: 5, title: 'Scheduing', src: '/resources/Scheduling_LQ_Trim.mov', thumbnail: '/resources/thumbnail5.jpg', position: [2,3], gridSpan: { columns: 2, rows: 2 }, sizeClass: 'size-80' },
    { id: 6, title: 'Personalized mentoring', src: '/resources/OneOnOne_LQ.mov', thumbnail: '/resources/thumbnail6.jpg', position: [3,1], gridSpan: { columns: 3, rows: 2 }, sizeClass: 'size-90' },
    ];

// Remove any video positioned at [3,3] to leave space for the logo
const filteredVideoData = videoData.filter(video => !(video.position[0] === 3 && video.position[1] === 3));

const VideoGrid = ({ darkMode }) => {
    return (
        <div className="video-grid">
            {filteredVideoData.map((video) => (
                <VideoCard 
                    key={video.id} 
                    video={video} 
                    darkMode={darkMode} 
                    className={`${video.sizeClass} grid-span-${video.gridSpan.columns}-${video.gridSpan.rows}`}
                    style={{
                        gridColumn: `span ${video.gridSpan.columns}`,
                        gridRow: `span ${video.gridSpan.rows}`,
                    }}
                />
            ))}
            <div className="logo-container"></div>
        </div>
    );
};

export default VideoGrid;
